export const SCRIPTS = {
	html2pdf: 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.9.3/html2pdf.bundle.min.js'
}

export const FAMILYPLANMAX = 7
export const FAMILYPLANMIN = 1

export const businessRoles: SelectOptionContext = [
	{
		label: 'Human Resources (HR) Department',
		value: 'Human Resources (HR) Department'
	},
	{
		label: 'Finance & Administration',
		value: 'Finance & Administration'
	},
	{
		label: 'Legal & Compliance',
		value: 'Legal & Compliance'
	},
	{
		label: 'Procurement Management',
		value: 'Procurement Management'
	},
	{
		label: 'Risk & Safety Management',
		value: 'Risk & Safety Management'
	},
	{
		label: 'Public Relations & Communications',
		value: 'Public Relations & Communications'
	},
	{
		label: 'External Support',
		value: 'External Support'
	},
	{
		label: 'Others',
		value: 'Others'
	}
]
export enum Providers {
	bastion = 'bastion',
	hygeia = 'hygeia'
}

export enum ProductAgeLimit {
	SeniorPlan = 85,
	Bastion = 70
}

export enum ValueMinimumLength {
	NIN = 11,
	GadgetMinPrice = 100000,
	VehicleMinPrice = 1000000
}
export const WAITING_PERIOD = 24 // This is in hours
// export const WAITING_PERIOD_5_DAYS = 5 * 24 * 60 * 60 * 1000 // This is in hours
export const WAITING_PERIOD_5_DAYS = 24 * 60 * 60 * 1000 // This is in hours

export const GADGET_INCIDENT_TYPES = {
	Burglary: 'Burglary',
	Theft: 'Theft',
	Screen_damage: 'Screen damage',
	Liquid_damage: 'Liquid damage'
} as const
export const VEHICLE_INCIDENT_TYPES = {
	Accidental_damage: 'Accidental damage',
	Stolen_vehicle: 'Stolen vehicle',
	Own_damage: 'Own damage'
} as const

export const TRAVEL_INCIDENT_TYPES = {
	Medical_expenses: 'Medical expenses',
	Missing_luggages: 'Missing luggages',
	Delayed_flights: 'Delayed flights'
}

export const ALL_INCIDENT_TYPES = {
	...GADGET_INCIDENT_TYPES,
	...VEHICLE_INCIDENT_TYPES,
	...TRAVEL_INCIDENT_TYPES
} as const
